import { type UseQueryResult, useQuery } from 'react-query';
import {
  TwoFactorConfigurationService,
} from '../../services/wealthlane-identity-services';
import { Wealthlane_Dtos_TwoFactor_TwoFactorConfigurationDto } from '../../services/wealthlane-identity-services/models/Wealthlane_Dtos_TwoFactor_TwoFactorConfigurationDto';

const useGetTwoFactorConfiguration = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Wealthlane_Dtos_TwoFactor_TwoFactorConfigurationDto | undefined, unknown> => {
  return useQuery(['getTwoFactorConfiguration'], async () => {
    return await handleRequest(
      TwoFactorConfigurationService.getApiIdentityApiTwoFactorConfiguration()
    );
  });
};

export default useGetTwoFactorConfiguration;
